import { create } from 'zustand';

let nextId = 0;

const useToastStore = create((set) => ({
  toasts: [],
  addToast: (message, type = 'info', duration = 3000, onClick = null) => {
    const id = ++nextId;
    set(s => ({ toasts: [...s.toasts, { id, message, type, onClick }] }));
    setTimeout(() => {
      set(s => ({ toasts: s.toasts.filter(t => t.id !== id) }));
    }, duration);
  },
  removeToast: (id) => set(s => ({ toasts: s.toasts.filter(t => t.id !== id) })),
}));

export default useToastStore;
